// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3MXc8","colMaxWidth":"Table_colMaxWidth__uzXOo"};